// src/components/ui/StatusToggle/StatusToggle.jsx
import PropTypes from "prop-types"
import { cn } from "../../../lib/utils"

export default function StatusToggle({ isActive, onToggle, className }) {
  const baseClasses =
    "inline-flex items-center gap-[5px] rounded-[var(--radius-md,4px)] px-2 py-0.5 text-[11px] font-medium cursor-pointer border-none transition-all"
  const activeClasses =
    "bg-[var(--status-success-bg)] text-[var(--status-success)] hover:bg-[rgba(22,163,74,0.16)]"
  const inactiveClasses =
    "bg-[var(--status-neutral-bg)] text-[var(--status-neutral)] hover:bg-[rgba(142,148,161,0.14)]"

  return (
    <button
      type="button"
      aria-pressed={isActive}
      data-testid="status-toggle"
      className={cn(baseClasses, isActive ? activeClasses : inactiveClasses, className)}
      onClick={(e) => {
        e.stopPropagation()
        onToggle()
      }}
    >
      <span
        data-slot="dot"
        className="size-[5px] rounded-full bg-current shrink-0"
        aria-hidden="true"
      />
      {isActive ? "Active" : "Inactive"}
    </button>
  )
}

StatusToggle.propTypes = {
  onToggle: PropTypes.func.isRequired,
  className: PropTypes.string,
  isActive: PropTypes.bool,
}
